import React from 'react'
import Button from 'reactstrap/lib/Button'
import Input from 'reactstrap/lib/Input'
import InputGroup from 'reactstrap/lib/InputGroup'
import InputGroupAddon from 'reactstrap/lib/InputGroupAddon'

class BlockTaxiChecker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      regInput: '',
      searchResult: null,
      searchError: null,
      searching: false,
    }
    this.handleRegChange = this.handleRegChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  handleRegChange(e) {
    // Only allow letters and numbers, max length 7
    const value = e.target.value
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase()
      .trim()
      .slice(0, 7)
    this.setState({ regInput: value, searchResult: null, searchError: null })
  }

  async handleSearch() {
    const reg = this.state.regInput
    if (!reg || reg.length < 1) {
      this.setState({ searchError: 'Please enter a valid registration.' })
      return
    }
    this.setState({ searching: true, searchResult: null, searchError: null })
    try {
      const res = await fetch(
        `https://cleanairgm.com/.netlify/functions/regSearch?reg=${reg}`
      )
      const data = await res.json()
      if (data && data.REG) {
        this.setState({ searchResult: data, searching: false })
      } else {
        this.setState({
          searchResult: null,
          searchError:
            'Registration not found, please contact your local authority if you believe your registration should be on this list.',
          searching: false,
        })
      }
    } catch (e) {
      this.setState({
        searchError: 'Server error. Please try again later.',
        searching: false,
      })
    }
  }

  render() {
    const { regInput, searchResult, searchError, searching } = this.state
    return (
      <div
        id={this.props.jumpLinkId}
        className="full-width-block pb-5  container pl-4 pr-4 pr-md-5 pl-md-5 "
      >
        <div className="mt-4">
          <h3>Check Eligibility</h3>
          <InputGroup className="mb-3" style={{ maxWidth: 400 }}>
            <Input
              placeholder="Enter registration"
              value={regInput}
              maxLength={7}
              onChange={this.handleRegChange}
              autoCapitalize="characters"
            />
            <InputGroupAddon addonType="append">
              <Button
                color="primary"
                onClick={this.handleSearch}
                disabled={searching || !regInput}
              >
                {searching ? 'Searching...' : 'Search'}
              </Button>
            </InputGroupAddon>
          </InputGroup>
          {searchResult && (
            <div className="mt-3 bg-light p-3 rounded">
              {searchResult.ROUND.toString().includes('1') && (
                <p className="font-lg">
                  Your vehicle is eligible for funding, subject to availability
                  of funding on a first-come, first-served basis.
                </p>
              )}
              {searchResult.ROUND.toString().includes('2') && (
                <p className="font-lg">
                  Your vehicle was eligible for funding under <b>round 2</b> -
                  Between 25 May and 19 June 2026, retrospective funding
                  applications were invited from eligible licensees who had
                  already replaced a non-compliant vehicle on or after 23
                  January 2025.
                  <br />
                  All eligible licensees were contacted directly by email and
                  given the opportunity to apply.
                  <br />
                  As this application window has now closed, we are not
                  currently accepting new applications from those who have
                  already replaced their non-compliant vehicle with a compliant
                  vehicle.
                </p>
              )}

              <p>
                <strong>Registration:</strong> {searchResult.REG}
              </p>
              <p>
                <strong>Funding Round:</strong> {searchResult.ROUND}
              </p>
              <p>
                <strong>Local Authority:</strong> {searchResult.LA}
              </p>
              <p>
                <strong>Wheelchair Accessible:</strong> {searchResult.WCA}
              </p>
            </div>
          )}
          {searchError && (
            <div className="mt-3 bg-light p-3 rounded">
              <strong>
                Vehicle is not eligible for funding and does not appear on the
                checker
              </strong>
              <br />
              <br />
              <span className="text-dark">
                If you have licensed with a GM authority before the 1st October
                2024 and remain licensed with them, your vehicle already meets
                the emission standards in that it is a Euro 4 (or a higher euro
                standard) petrol vehicle, Euro 6 diesel vehicle or a Zero
                Emission Capable (ZEC) vehicle; and is not eligible for funding.
                <br />
                <br />
                If you have licensed with a GM authority after the 1st October
                2024, you are not eligible for funding.
                <br />
                <br />
                If you think this is incorrect, check again by entering your
                vehicle registration number. If you still think this is
                incorrect, please contact your GM licensing authority.
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default BlockTaxiChecker
